import { createFileRoute } from '@tanstack/react-router';

import { ExternalReportingListPage } from '@/features/external-reporting/components';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/external-reporting/')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.externalReporting'),
  }),
  component: ExternalReportingIndexRoute,
});

function ExternalReportingIndexRoute() {
  return <ExternalReportingListPage />;
}
